export default {
    apiUrl    : 'https://api.powerplay.gg',
    apiPrefix : '/',
    ga4TrackerId: 'G-94T2EVC7P9',
    apiKeyAmplitude: 'ad499c6ac628301f7fb1f9c06cb1e880',
    growthBookClientKey: 'sdk-KdhNjAneMhvDQJja',
    environment: 'production'
};
